import { getJWT } from "./etcUtils";

const getToken = () => {
  const tokenString = getJWT();
  return JSON.parse(tokenString);
};

export default getToken;
